import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Slider, Stack, TextField, Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Grid2';
import StepCard from '@/components/formik-stepper/components/StepCard';
import Sidebar from '../Sidebar';
import { useResponsive } from '@/hooks';
import { Product as IProduct, products } from '../constants';

const Product = () => {
  const { isMobile } = useResponsive();
  const { handleChange, values } = useFormikContext<{
    product: string;
    quantity: number;
  }>();

  const productQuantity = useMemo(() => {
    const product = Object.values(products).find(
      (product: IProduct) => product.id === values.product
    );
    return product?.minQuantity ?? 0;
  }, [values.product]);

  const marks = useMemo(() => {
    return [
      {
        label: productQuantity,
        value: Number(productQuantity),
      },
      {
        label: Number(productQuantity) * 5,
        value: Number(productQuantity) * 5,
      },
      {
        label: Number(productQuantity) * 10,
        value: Number(productQuantity) * 10,
      },
    ];
  }, [productQuantity]);

  return (
    <Grid container spacing={3}>
      <Grid size={{ md: 9 }} sx={{ backgroundcolor: 'green' }}>
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Typography variant="h4">Producto</Typography>
            <Grid container spacing={3}>
              {Object.values(products).map((product: IProduct) => (
                <Grid size={{ xs: 6, sm: 4, lg: 3 }} key={product.id}>
                  <StepCard
                    name="product"
                    title={product.label}
                    img={product.img}
                    icon={product.icon}
                    value={product.id}
                    onClick={handleChange}
                  />
                </Grid>
              ))}
            </Grid>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="h4">Cantidad</Typography>
            <Paper sx={{ padding: 3 }}>
              <Stack
                spacing={5}
                direction={{ xs: 'column-reverse', md: 'row-reverse' }}
                alignItems={'top'}
              >
                <TextField
                  label="Otra cantidad"
                  size="small"
                  type="number"
                  name="quantity"
                  defaultValue={productQuantity}
                  value={Number(values.quantity ?? productQuantity)}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Slider
                  color="info"
                  valueLabelDisplay="auto"
                  min={Number(productQuantity)}
                  max={Number(productQuantity) * 10}
                  marks={marks}
                  defaultValue={productQuantity}
                  value={values.quantity ?? productQuantity}
                  disabled={!values.product?.length}
                  onChange={(_, value) =>
                    handleChange({
                      target: {
                        name: 'quantity',
                        value,
                      },
                    })
                  }
                />
              </Stack>
            </Paper>
          </Stack>
        </Stack>
      </Grid>

      {!isMobile ? (
        <Grid size={{ xs: 12, md: 3 }} sx={{ backgroundcolor: 'orange' }}>
          <Sidebar />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Product;
